import { IconPencil } from "@tabler/icons-react";
import classes from "./home.module.scss";
import { AllSectionsTile, SectionTile } from "./SectionTile";
import { HomeSection, SectionBadge } from "./sections";

type Props = {
  shortcuts: HomeSection[];
  badges: Partial<Record<SectionBadge, number>>;
  onEdit?: () => void;
};

export default function ShortcutGrid({ shortcuts, badges, onEdit }: Props) {
  return (
    <section className={classes.section} aria-labelledby="home-shortcuts-title">
      <div className={classes.sectionHead}>
        <h2 id="home-shortcuts-title" className={classes.sectionTitle}>
          میانبرها
        </h2>
        {onEdit && (
          <button type="button" className={classes.textLink} onClick={onEdit}>
            <IconPencil size={16} stroke={1.7} aria-hidden />
            ویرایش
          </button>
        )}
      </div>
      <div className={`${classes.card} ${classes.grid}`}>
        {shortcuts.map((section) => (
          <SectionTile key={section.id} section={section} count={section.badge ? badges[section.badge] : undefined} />
        ))}
        <AllSectionsTile />
      </div>
    </section>
  );
}
